<!-- 首页参展商直播 -->
<template>
  <div :option="option">
    <el-row class="CanZhanWai" :gutter="20" type="flex">
      <el-col class="CanZhan" :xs="12" :sm="12">
        <div class="liveStreamILeft">
          <img class="liveStreamImages lazy-img-fadein" v-lazy="$funcs.compressImage(this.images, 658, 380)" />
          <div class="liveMask" @click="goLive()">
            <p class="liveTitle">{{ this.liveTitle }}</p>
            <div class="liveCountdown"><p>{{ $t('homes.distanceFromLiveTime.time') }}:{{ this.time | formatDate('all') }}</p></div>
            <div class="liveBtn"><p class="liveBtnP">{{ $t('homes.bookingNow') }}</p></div>
          </div>
        </div>
      </el-col>
      <el-col class="CanZhan" :xs="12" :sm="12">
        <div class="liveStreamIRight">
          <template v-if="!isMobile">
            <swiper :options="swiperOption" class="liveStreamIRightSwiper" ref="mySwiper">
              <swiper-slide
                class="swiper-slide liveSlide"
                v-for="(item, index) in option"
                :key="index"
                :class="item.liveChecked ? 'liveSlideHover swiper-slide liveSlide' : 'swiper-slide liveSlide'"
              >
                <div class="liveSlideTop">
                  <span class="liveDate">{{ item.liveStartDate | formatDate('day') }}</span>
                  <span class="liveLable">{{ item.liveName }}</span>
                </div>
                <div class="liveSlideCon"></div>
                <div class="liveSlideBot">
                  <span class="liveTime">{{ item.liveStartDate | formatDate('hours') }}</span>
                  <span class="livecomName">{{ item.liveSponsorName }}</span>
                </div>
                <div class="liveSlideMask" @click="liveSlideClick(item, index, option)"></div>
              </swiper-slide>
            </swiper>
          </template>
          <template v-else>
            <div class="liveStreamIRightSwiper">
              <div
                class="swiper-slide liveSlide"
                v-for="(item, index) in option"
                :key="index"
                :class="item.liveChecked ? 'liveSlideHover swiper-slide liveSlide' : 'swiper-slide liveSlide'"
              >
                <div class="liveSlideTop">
                  <span class="liveDate">{{ item.liveStartDate | formatDate('day') }}</span>
                  <span class="liveLable">{{ item.liveName }}</span>
                </div>
                <div class="liveSlideCon"></div>
                <div class="liveSlideBot">
                  <span class="liveTime">{{ item.liveStartDate | formatDate('hours') }}</span>
                  <span class="livecomName">{{ item.liveSponsorName }}</span>
                </div>
                <div class="liveSlideMask" @click="liveSlideClick(item, index, option)"></div>
              </div>
            </div>
          </template>
          
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import { browser } from '@/utils/function'
var vm = null;
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  mixins: [eventMixin, inviteMixin],
  components: {},
  data() {
    return {
      isMobile: Boolean,
      images:'',
      liveTitle:'',
      liveState:'',
      scope: '',
      time:'',
      options:[],
      id:'',
      swiperOption: {
        pagination: '.swiper-pagination',
        direction: 'vertical',
        slidesPerView: 'auto',
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        spaceBetween: 20,
        initialSlide: 0,
        lazy: {
            loadPrevNext: true
        },
        on: {
          click: function() {
            const realIndex = this.realIndex
            vm.handleClickSlide(realIndex)
          }
        }
      }
    }
  },
  watch: {
    option: function() {
      let arr1 = []
      for (let i in this.option) {
        if (this.option[i]['liveState'] == true) {
          this.swiperOption.initialSlide = Number(i)
          this.images = this.option[i]['liveImgUrl']
          this.time = this.option[i]['liveStartDate']
          this.liveTitle = this.option[i]['liveName']
          this.id = this.option[i]['id']
          this.option[i]['liveChecked'] = true
          this.liveState = this.option[i]['liveState']
          return
        } else {
          arr1.push(this.option[i])
        }
      }
      if (arr1.length === this.option.length) {
        if (arr1.length != 0) {
          this.images = arr1[0]['liveImgUrl']
          this.time = this.option[0]['liveStartDate']
          this.liveTitle = this.option[0]['liveName']
          this.option[0]['liveChecked'] = true
          this.liveState = this.option[0]['liveState']
          this.id = this.option[0]['id']
          this.swiperOption.initialSlide = 0
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    vm = this
    let arr1 = []
    for (let i in this.option) {
      if (this.option[i]['liveState'] == true) {
        this.swiperOption.initialSlide = Number(i)
        this.images = this.option[i]['liveImgUrl']
        this.time = this.option[i]['liveStartDate']
        this.liveTitle = this.option[i]['liveName']
        this.id = this.option[i]['id']
        this.option[i]['liveChecked'] = true
        this.liveState = this.option[i]['liveState']
        this.actorId = this.option[i]['liveSponsorId']
        this.scope = this.option[i]['scope']
        return
      } else {
        arr1.push(this.option[i])
      }
    }
    if (arr1.length === this.option.length) {
      if (arr1.length != 0) {
        this.images = arr1[0]['liveImgUrl']
        this.time = this.option[0]['liveStartDate']
        this.liveTitle = this.option[0]['liveName']
        this.option[0]['liveChecked'] = true
        this.liveState = this.option[0]['liveState']
        this.id = this.option[0]['id']
        this.actorId = this.option[0]['liveSponsorId']
        this.scope = this.option[0]['scope']
        this.swiperOption.initialSlide = 0
      }
    }
  },
  mounted() {
    console.log(browser.mobile)
    this.isMobile = browser.mobile
  },
  methods: {
    handleClickSlide() {},
    liveSlideClick(data, index, option) {
      for (let i in option) {
        if (i == index) {
          option[i]['liveChecked'] = true
          this.liveTitle = option[i]['liveName']
          this.liveState = option[i]['liveState']
          this.images = option[i]['liveImgUrl']
          this.time = option[i]['liveStartDate']
          this.id = option[i]['id']
          this.actorId = this.option[i]['liveSponsorId']
          this.scope = option[i]['scope']
        } else {
          option[i]['liveChecked'] = false
          this.id = ''
          this.scope = ''
        }
      }
    },
    goLive() {
      // this.liveEvent(this.id)
      this.pageDetail({
        id: this.id,
        scope: this.scope,
        liveState: this.liveState,
        exhibitorId: this.actorId
      }, 'live', true, 'exhibitor')
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
